module.exports = __webpack_public_path__ + "img/cultureClose1.e0026c0d.png";